import React, { useState, useEffect } from "react";
import { getDrivenlists } from "../../services/wms";

const Drivenprofile = () => {

  const [list, setlist] = useState([]);

  useEffect(() => {
    
    const getdata = async () => {
      const { data: result } = await getDrivenlists();
      if (result.status === "success") {
        setlist(result.data.list);
      }
    };
    getdata();
  }, []);




  return (
    <div className="container-fluid">
      <div className="row course-list list m-1">
        {list &&
          list.length > 0 &&
          list.map((item, index) => {
            return (
              <div
                key={index}
                className="card text-dark p-0 mb-2 me-2  col-xs-12 col-sm-2"
              >
                <div className="container-fluid">
                  <div className="d-flex justify-content-between mt-2">
                    <span className="badge rounded-pill bg-secondary"> {item.no}</span>
                  </div>
                  <div className="row no-gutters align-items-center justify-content-center">
                    <div className="col-auto text-center mb-2 p-1 text-center">
                      <img
                        src={item.imageurl}
                        className="rounded-circle "
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title=""
                        alt=""
                        style={{ height: 100, width: 100 }}
                      />
                    
                    </div>
                    <div className="col-auto ms-2">
                      <div className="card-body p-1">
                        <div className="card-text">
                          <h6
                            className="card-title d-inline me-2"
                            style={{ fontSize: 14 }}
                          >
                            {item.fnamet}
                          </h6>
                          <h6
                            className="card-title d-inline me-2"
                            style={{ fontSize: 14 }}
                          >
                            {item.lnamet}
                          </h6>
                        </div>
                        <div className="card-text">
                          <h6
                            className="card-text d-inline me-2"
                            style={{ fontSize: 14 }}
                          >
                            <span
                              aria-hidden="true"
                              className="bi bi-phone-fill"
                            />{" "}
                            {item.telephone}
                          </h6>
                          <h6
                            className="card-text d-inline"
                            style={{ fontSize: 14 }}
                          >
                            <span
                              aria-hidden="true"
                              className="fa fa-building"
                            />{" "}
                            {item.profileid}
                          </h6>
                        </div>
                     
                        <button
                          className="btn btn-primary"
                          style={{ fontSize: 12 }}
                        >
                          <i className="bi bi-camera-fill me-2" />

                          <span>Upload</span>
                        </button>
                        <button
                          className="btn btn-danger ms-1"
                          style={{ fontSize: 12 }}
                        >
                          <i className="bi bi-trash me-2"/>
                          <span>Delete</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

        <span
          aria-hidden="true"
          className="fa fa-arrow-circle-up scrollTop"
          style={{ height: 40, display: "none" }}
        />
      </div>
    </div>
  );
};

export default Drivenprofile;
